module.exports = __webpack_public_path__ + "prod/1.42.2/img/banner-bg.3d2530f4.png";